export default __webpack_public_path__ + "static/media/mepExpandCover.8ab47b52.jpg";